module.exports = __webpack_public_path__ + "img/V92.190340b3.jpg";